import { render, staticRenderFns } from "./AvailableComponentItems.vue?vue&type=template&id=8159d82e"
import script from "./AvailableComponentItems.vue?vue&type=script&lang=ts"
export * from "./AvailableComponentItems.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AvailableComponentItems.vue?vue&type=style&index=1&id=8159d82e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports